import { render, staticRenderFns } from "./GlobalPreviewIframe.vue?vue&type=template&id=089ba8ff"
import script from "./GlobalPreviewIframe.vue?vue&type=script&lang=js"
export * from "./GlobalPreviewIframe.vue?vue&type=script&lang=js"
import style0 from "./GlobalPreviewIframe.vue?vue&type=style&index=0&id=089ba8ff&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports